import { forwardRef, useState, useEffect } from 'react';

import Dialog from '@mui/material/Dialog';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { actualizarSeccionDiapositiva } from '../../../store/slices/seccion-diapositiva';

import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';
import { TextField } from '@mui/material';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Diapositiva from './Diapositiva';


const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
}
);

type Props = {
    setOpen: any
    open: boolean
}

const EditarDiapositiva = ({ setOpen, open }: Props) => {

    const dispatch = useDispatch<AppDispatch>();

    const { seccion } = useSelector((state: RootState) => state.seccion);
    const { usuario } = useSelector((state: RootState) => state.usuario);

    const [numeroPaginas, setNumeroPaginas] = useState(1);
    const [pagina, setPagina] = useState(1);
    const [contenido, setContenido] = useState('');

    useEffect(() => {
        const { diapositivas } = seccion;

        if (diapositivas) {
            setNumeroPaginas(diapositivas.length);
            setContenido(diapositivas[pagina - 1].contenido);
            setPagina(diapositivas[pagina - 1].pagina);
        }

    }, [seccion, pagina])


    const handleClose = () => {
        handleGuardarCambios()
        setOpen(false);
    };


    const handleGuardarCambios = () => {
        const { diapositivas } = seccion;

        if (diapositivas) {
            const diapositivasActualizada = diapositivas.map(item =>
                item.pagina === pagina ? { pagina: pagina, contenido: contenido } : item
            )

            const diapositiva = {
                cid: seccion.cid,
                mid: seccion.mid,
                bid: seccion.bid,
                sid: seccion.sid,
                autor: `${usuario.nombre} ${usuario.apellido}`,
                diapositivas: diapositivasActualizada,
            }

            dispatch(actualizarSeccionDiapositiva(diapositiva))
        }
    }

    const handleAgregarDiapositiva = async () => {

        const { diapositivas } = seccion;

        if (diapositivas) {
            const diapositivasGuardar = diapositivas.map(item =>
                item.pagina === pagina ? { pagina: pagina, contenido: contenido } : item
            )

            const diapositivaGuardar = {
                cid: seccion.cid,
                mid: seccion.mid,
                bid: seccion.bid,
                sid: seccion.sid,
                autor: `${usuario.nombre} ${usuario.apellido}`,
                diapositivas: diapositivasGuardar,
            }

            await dispatch(actualizarSeccionDiapositiva(diapositivaGuardar))

            const arrayFirst = diapositivasGuardar.slice(0, pagina);
            const arrayMiddle = { pagina: pagina + 1, contenido: 'Edite esta diapositiva' };
            const arrayEnd = diapositivasGuardar.slice(pagina);

            const diapositivasActualizada = arrayFirst.concat(arrayMiddle, arrayEnd).map((item, index) => {
                return ({
                    pagina: index + 1,
                    contenido: item.contenido
                })
            })

            const diapositivaActualizada = {
                cid: seccion.cid,
                mid: seccion.mid,
                bid: seccion.bid,
                sid: seccion.sid,
                autor: `${usuario.nombre} ${usuario.apellido}`,
                diapositivas: diapositivasActualizada,
            }

            await dispatch(actualizarSeccionDiapositiva(diapositivaActualizada));

            setPagina(pagina + 1);
        }
    }

    const handleEliminarDiapositiva = () => {

        const { diapositivas } = seccion;

        if (diapositivas && diapositivas.length > 1) {
            const arrayFirst = diapositivas.slice(0, pagina - 1);
            const arrayEnd = diapositivas.slice(pagina);

            const diapositivasActualizada = arrayFirst.concat(arrayEnd).map((item, index) => {
                return ({
                    pagina: index + 1,
                    contenido: item.contenido
                })
            })

            const diapositiva = {
                cid: seccion.cid,
                mid: seccion.mid,
                bid: seccion.bid,
                sid: seccion.sid,
                autor: `${usuario.nombre} ${usuario.apellido}`,
                diapositivas: diapositivasActualizada,
            }

            setPagina(pagina > 1 ? pagina - 1 : pagina);
            dispatch(actualizarSeccionDiapositiva(diapositiva));
        }
    }

    const handlePreviousPage = () => {
        handleGuardarCambios()
        if (pagina > 1) {
            setPagina(pagina - 1)
        }
    }

    const handleNextPage = () => {
        handleGuardarCambios()
        if (pagina < numeroPaginas) {
            setPagina(pagina + 1)
        }
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={open}
                // onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            onClick={handleGuardarCambios}
                            color="inherit"
                        >
                            <SaveIcon />
                        </IconButton>
                        <Typography sx={{ ml: 1, mr: 5 }} variant="h6" component="div">
                            Guardar
                        </Typography>

                        <IconButton
                            onClick={handleAgregarDiapositiva}
                            color="inherit"
                        >
                            <AddIcon />
                        </IconButton>
                        <Typography sx={{ ml: 1, mr: 5 }} variant="h6" component="div">
                            Agregar diapositiva
                        </Typography>

                        <IconButton
                            onClick={handleEliminarDiapositiva}
                            color="inherit"
                            disabled={numeroPaginas < 2}
                        >
                            <DeleteIcon />
                        </IconButton>
                        <Typography sx={{ ml: 1, flex: 1 }} variant="h6" component="div">
                            Eliminar diapositiva
                        </Typography>

                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 1 }} variant="h6" component="div">
                            Cerrar
                        </Typography>

                    </Toolbar>
                </AppBar>

                <div className="container my-5">
                    <div className="row">
                        <div className="col-6">

                            <TextField
                                id="outlined-multiline-static"
                                label="Diapositiva"
                                multiline
                                rows={20}
                                // defaultValue="Default Value"
                                value={contenido}
                                onChange={(e: any) => setContenido(e.target.value)}
                                fullWidth
                            />
                        </div>
                        <div className="col-6">
                            <Diapositiva contenido={contenido} />
                        </div>
                    </div>
                </div>

                <footer
                    style={{
                        position: 'fixed',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        backgroundColor: '#2e76d2',
                        color: 'white',
                        textAlign: 'center',
                        padding: '1em',
                        boxShadow: '0px 5px 15px 0px'
                    }}
                >
                    <div className="row">
                        <div className="col-12">
                            <IconButton
                                color="inherit"
                                onClick={handlePreviousPage}
                            >
                                <ArrowLeftIcon />
                            </IconButton>

                            {pagina} / {numeroPaginas}

                            <IconButton
                                color="inherit"
                                onClick={handleNextPage}
                            >
                                <ArrowRightIcon />
                            </IconButton>
                        </div>
                    </div>
                </footer>
            </Dialog>
        </div>
    )
}

export default EditarDiapositiva;